<template>
  <div class="header-container">
    <div class="header-main" :class="topValue">
      <div class="left-header-content">
        <div v-if="navigationMode !== 'topCross'">
          <i class="el-icon-s-fold fs-24" v-if="!isCollapse" @click="handleMenu"></i>
          <i class="el-icon-s-unfold fs-24" v-if="isCollapse" @click="handleMenu"></i>
        </div>
        <!-- <el-button @click="handleMenu" icon="el-icon-menu" size="mini"></el-button> -->
        <!-- 面包屑 -->
        <breadcrumb v-if="navigationMode === 'leftVertical' || navigationMode === 'leftColumn'" class="breadcrumb-container" />
        <header-menu-aside v-if="navigationMode === 'topCross'"></header-menu-aside>
      </div>
      <div class="right-header-content">
        <div class="header-more">
          <el-dropdown @command="handleLanguage">
            <el-button :class="topValue" icon="icon-yuyanqiehuan" circle></el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="chinese_simplified">简体中文</el-dropdown-item>
              <el-dropdown-item divided command="english">English</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <el-dropdown @command="handleCommand">
          <span class="el-dropdown-link">
            <img class="user-photo" src="../../../assets/images/system/avatar.gif" alt="">
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="userCenter">个人中心</el-dropdown-item>
            <el-dropdown-item divided command="layout">退出</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-divider direction="vertical"></el-divider>
        <div class="header-more">
          <el-tooltip class="item" effect="dark" content="系统设置" placement="bottom">
            <el-button :class="topValue" icon="el-icon-more" circle @click="systemSetting = true"></el-button>
          </el-tooltip>
        </div>
      </div>
    </div>
    <el-dialog title="个人信息" :visible.sync="dialogVisibleInfo" :before-close="handleClose">
      <el-form :model="userInfo" ref="userInfo">
        <el-form-item label="用户名" :label-width="formLabelWidth">
          <el-input v-model="userInfo.userName" autocomplete="off" :disabled="true"></el-input>
        </el-form-item>
        <el-form-item label="昵称" :label-width="formLabelWidth">
          <el-input v-model="userInfo.nickName" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="电话" :label-width="formLabelWidth">
          <el-input v-model="userInfo.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="邮件地址" :label-width="formLabelWidth">
          <el-input v-model="userInfo.email" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="密码" :label-width="formLabelWidth">
          <el-input v-model="userInfo.passWord" autocomplete="off" placeholder="******" show-password></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleInfo = false">取 消</el-button>
        <el-button type="primary" @click="onUpdateUserInfo">确 定</el-button>
      </span>
    </el-dialog>

    <el-drawer title="系统设置" :visible.sync="systemSetting" direction="rtl">
      <div class="systemSetting">
        <div class="title">导航模式</div>
        <div class="navigationMode">
          <el-tooltip class="item" effect="dark" content="左侧垂直" placement="top">
            <div class="space-item flex" :class="navigationMode == 'leftVertical' ? 'active' : ''"
              @click="handleNavigationMode('leftVertical')">
              <div class="nav-mode-left"></div>
              <div class="nav-mode-right"></div>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="顶部横向" placement="top">
            <div class="space-item" :class="navigationMode == 'topCross' ? 'active' : ''"
              @click="handleNavigationMode('topCross')">
              <div class="nav-mode-top"></div>
              <div class="nav-mode-centre"></div>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="左侧垂直拆分" placement="top">
            <div class="space-item" :class="navigationMode == 'leftSplit' ? 'active' : ''"
              @click="handleNavigationMode('leftSplit')">
              <div class="nav-mode-top"></div>
              <div class="nav-mode-centre">
                <div class="nav-mode-left"></div>
              </div>
            </div>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="左侧垂直分栏" placement="top">
            <div class="space-item flex" :class="navigationMode == 'leftColumn' ? 'active' : ''"
              @click="handleNavigationMode('leftColumn')">
              <div class="nav-mode-left"></div>
              <div class="nav-mode-left nav-mode-left-tow"></div>
              <div class="nav-mode-right"></div>
            </div>
          </el-tooltip>
        </div>
        <div class="title">导航风格</div>
        <el-divider>侧边栏</el-divider>
        <SegmentController v-model="sideValue" :options="options" @change="sideChange" />
        <el-divider>顶栏</el-divider>
        <SegmentController v-model="topValue" :options="options" @change="TopChange" />
        <div class="title">系统功能</div>
        <div class="systemFunction">
          <div class="flex flex-jc-sb">
            <div>折叠菜单</div>
            <el-switch v-model="menuCollapsible" @change="menuCollapsibleChange">
            </el-switch>
          </div>
          <div class="flex flex-jc-sb flex-ai-c">
            <div>左侧菜单宽度</div>
            <el-input-number v-model="sideWidth" :min="1" :max="500" label="描述文字" controls-position="right"
              @change="widthChange"></el-input-number>
          </div>
        </div>
        <div class="title">页面显示</div>
        <div class="systemFunction">
          <div class="flex flex-jc-sb">
            <div>显示多页签</div>
            <el-switch v-model="multiTabShow" @change="multiTabShowChange">
            </el-switch>
          </div>
        </div>
        <div class="title">路由动画</div>
        <div class="systemFunction">
          <div class="flex flex-jc-sb">
            <div>切换动画</div>
            <el-switch v-model="switchAnimation" @change="switchAnimationChange">
            </el-switch>
          </div>
          <div class="flex flex-jc-sb flex-ai-c">
            <div>动画类型</div>
            <el-select v-model="switchMode" placeholder="请选择" @change="switchModeChange">
              <el-option label="淡入" value="fade"></el-option>
              <el-option label="消退" value="breadcrumb"></el-option>
              <el-option label="底部消退" value="breadcrumb-bottom"></el-option>
              <el-option label="缩放消退" value="breadcrumb-zoom"></el-option>
              <el-option label="滑动" value="fade-transform"></el-option>
              <el-option label="中心缩放" value="el-zoom-in-center"></el-option>
              <el-option label="顶部缩放" value="el-zoom-in-top"></el-option>
              <el-option label="低部缩放" value="el-zoom-in-bottom"></el-option>
              <el-option label="弹出" value="bounce"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import Breadcrumb from "../Breadcrumb/index.vue";
import HeaderMenuAside from "../menu/HeaderMenuAside.vue";
import { getUserInfo, updateUser } from "@/api/auth/user";
import { logout } from "@/api/auth/login";
export default {
  name: "CommonHeader",
  components: {
    Breadcrumb,
    HeaderMenuAside
  },
  data() {
    return {
      dialogVisibleInfo: false,
      formLabelWidth: "120px",
      userInfo: {},
      asideCollapse: false,
      systemSetting: false,
      options: [
        { label: "深色", value: "darkColor" },
        { label: "浅色", value: "lightColor" },
      ],
      menuCollapsible: false,
      num: 200,
    };
  },
  created() {
    this.menuCollapsible = !this.$store.state.tab.isCollapse;
  },
  watch: {
    asideCollapse(val) {
      console.log(val);
    },
  },
  computed: {
    // 侧边栏
    sideValue() {
      return this.$store.state.settings.sideValue;
    },
    // 顶部栏
    topValue() {
      return this.$store.state.settings.topValue;
    },
    // 侧边栏状态
    isCollapse() {
      this.menuCollapsible = !this.$store.state.tab.isCollapse;
      return this.$store.state.tab.isCollapse;
    },
    // 导航模式
    navigationMode() {
      return this.$store.state.settings.navigationMode;
    },
    // 侧边栏宽度
    sideWidth: {
      get() {
        return this.$store.state.settings.sideWidth;
      },
      set(value) {
        this.$store.commit("SET_SIDE_WIDTH", value); // 触发 Vuex mutation
      },
    },
    // 切换动画
    switchAnimation: {
      get() {
        return this.$store.state.settings.switchAnimation;
      },
      set(value) {
        this.$store.commit("SET_SWITCH_ANIMATION", value); // 触发 Vuex mutation
      },
    },
    // 切换动画模式
    switchMode: {
      get() {
        return this.$store.state.settings.switchMode;
      },
      set(value) {
        this.$store.commit("SET_SWITCH_MODE", value); // 触发 Vuex mutation
      },
    },
    // 显示多页签
    multiTabShow: {
      get() {
        return this.$store.state.settings.multiTabShow;
      },
      set(value) {
        this.$store.commit("SET_MULTI_TAB_SHOW", value); // 触发 Vuex mutation
      },
    },
    // Extract background color logic based on sideValue
    menuBackgroundColor() {
      return this.sideValue === 'darkColor' ? '#2b2f3a' : '#fff';
    },
    // Extract text color logic based on sideValue
    menuTextColor() {
      return this.sideValue === 'darkColor' ? '#fff' : 'rgba(0, 0, 0, 0.88)';
    },
    // Extract class for logo text style
    logoClass() {
      return this.sideValue;
    },

    // 导航栏模式 
    navigationMode() {
      return this.$store.state.settings.navigationMode;
    },
  },
  methods: {
    handleLanguage(item) {
      if (item !== localStorage.getItem('language')) {
        localStorage.setItem('language', item)
        this.$translate.changeLanguage(localStorage.getItem('language'))
      }
      this.$translate.execute()
    },
    handleMenu() {
      if (this.$store.state.tab.isCollapse) {
        this.$store.dispatch('updateCollapseMenu', false)
      } else {
        this.$store.dispatch('updateCollapseMenu', true)
      }
    },
    handleCommand(command) {
      if (command === 'layout') {
        this.$confirm("此操作将注销登录, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            logout().then((resp) => {
              window.sessionStorage.removeItem('token');
              window.sessionStorage.removeItem('userInfo');
              window.sessionStorage.removeItem('menuList');
              this.$router.replace('/login');
            });
            setTimeout(() => {
              window.sessionStorage.removeItem('token');
              window.sessionStorage.removeItem('userInfo');
              window.sessionStorage.removeItem('menuList');
              this.$router.replace('/login');
            }, 500);
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
          });
      } else if (command === 'userCenter') {
        this.dialogVisibleInfo = true;
        getUserInfo().then((resp) => {
          this.userInfo = resp.data;
        });
      }
    },
    handleClose(done) {
      done();
      // this.$confirm('确认关闭？')
      //   .then(_ => {
      //     done();
      //   })
      //   .catch(_ => { });
    },
    onUpdateUserInfo() {
      updateUser(this.userInfo).then((resp) => {
        this.dialogVisibleInfo = false;
      });
    },
    sideChange(value) {
      this.$store.dispatch('setSideValue', value);
    },
    TopChange(value) {
      this.$store.dispatch('setTopValue', value);
    },
    handleNavigationMode(value) {
      this.$store.dispatch('setNavigationMode', value);
    },
    menuCollapsibleChange(value) {
      this.$store.dispatch('updateCollapseMenu', !value);
    },
    widthChange(value) {
      this.$store.commit('SET_SIDE_WIDTH', value);
    },
    switchAnimationChange(value) {
      this.$store.dispatch('setSwitchAnimation', value);
    },
    multiTabShowChange(value) {
      this.$store.dispatch('setMultiTabShow', value);
    },
    switchModeChange(value) {
      console.log(value);
      this.$store.dispatch('setSwitchMode', value);
    }
  },
};
</script>

<style lang="scss" scoped>
.header-container::v-deep {

  .right-header-content {
    display: flex;
    align-items: center;

    value .header-language {
      color: #fff;
      margin-right: 10px;
    }

    .user-photo {
      widows: 40px;
      height: 40px;
      border-radius: 50%;
    }
  }

  .el-drawer {
    width: 500px !important;

    .navigationMode {
      display: flex;
      gap: 20px;
      justify-content: center;

      .space-item {
        width: 64px;
        height: 48px;
        border: 1px solid #f0f0f0;
        border-radius: 10px;
        padding: 5px;

        &.active {
          border-color: #2d8cf0;

          .nav-mode-centre,
          .nav-mode-right {
            background-color: #2d8cf0;
            opacity: 0.3;
          }
        }

        .nav-mode-left {
          width: 20px;
          height: 100%;
          background-color: #18181c;
          border-radius: 5px 0 0 5px;
        }

        .nav-mode-right {
          width: 60px;
          height: 100%;
          background-color: #e0e0e6;
          border-radius: 0 5px 5px 0;
        }

        .nav-mode-centre {
          width: 100%;
          height: calc(100% - 13px);
          background-color: #e0e0e6;
          border-radius: 0 0 5px 5px;

          .nav-mode-left {
            border-radius: 0 0 0 5px;
            width: 13px;
          }
        }

        .nav-mode-left-tow {
          border-radius: 0;
          border-left: 1px solid #545454;
        }

        .nav-mode-top {
          width: 100%;
          height: 13px;
          border-radius: 5px 5px 0 0;
          background-color: #18181c;
        }
      }
    }

    .systemFunction {
      .flex {
        padding: 20px 0;
      }
    }
  }

  .el-drawer__header {
    span {
      color: #000;
      font-size: 20px;
      font-weight: 500;
    }
  }

  .systemSetting {
    padding: 20px;
    overflow: auto;

    .title {
      margin: 24px 0;
      font-size: 18px;
      font-weight: 600;
    }

    .el-divider__text {
      font-size: 16px;
    }
  }
}

.header-main::v-deep {
  padding: 0 20px;
  height: 64px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 0 0 10px 10px;

  .text {
    color: #fff;
    font-size: 14px;
    margin-left: 10px;
  }

  .left-header-content {
    display: flex;
    align-items: center;

    .menu-button {
      margin-right: 20px;
    }
  }

}

.right-header-content::v-deep {
  display: flex;
  gap: 8px;

  .el-button {
    font-size: 30px;
    background-color: transparent;
    border: none;
  }
}
</style>
